import { Register } from "../../components/Auth/Register";


export default function RegistrationPage() {

    return (
        <Register />
    );
}
